import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';
import { APP_DOWNLOAD_COMPONENT_NAME, appDownloadInputs } from './AppDownload.config';

export { appDownloadInputs };

const AppDownload = dynamic(() => import('./AppDownload').then((m) => ({ default: m.AppDownload })));

const AppDownloadConfig = {
  name: APP_DOWNLOAD_COMPONENT_NAME,
  friendlyName: 'App Download',
  inputs: appDownloadInputs,
};

Builder.registerComponent(AppDownload, AppDownloadConfig);
